/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

// import { AUTH_ROLES } from '@/constants/roles.constant';
import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    component: () =>
      import(
        /* webpackChunkName: "mentions" */ '@/modules/mentions/scenes/mentions-list/mentions-list.scene.vue'
      ),
    meta: { requiresAuth: true, roles: ['AUTH_ROLES.PARTNERSHIP_SIMPLE_USER'] },
    name: ROUTES.MENTIONS.MENTIONS_LIST,
    path: 'mentions'
  }
] as RouteConfig[];
